import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CONSTANTS } from '../../../constants';
import { dataPumpAPI } from '../../api';
import logger from '../../logger';
export var TransferStatusImportLayer =
/*#__PURE__*/
function () {
  function TransferStatusImportLayer() {
    _classCallCheck(this, TransferStatusImportLayer);
  }

  _createClass(TransferStatusImportLayer, [{
    key: "getImportTransferLog",

    /**
     * Getter for transfer status of import
     * @param limit
     * @param offset
     * @returns Promise<TransferLog[]>
     */
    value: function getImportTransferLog(limit, offset) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof limit !== 'number' && !parseInt(limit)) limit = null;
                if (typeof offset !== 'number' && !parseInt(offset)) offset = null;
                if (typeof limit === 'string' && parseInt(limit)) limit = parseInt(limit);
                if (typeof offset === 'string' && parseInt(offset)) offset = parseInt(offset);
                url = CONSTANTS.API.ENDPOINTS.TRANSFER_STATUS_IMPORT + "".concat(offset || limit ? "?" : '').concat(typeof limit === 'number' ? "limit=".concat(limit) : '').concat(offset && limit ? "&" : '').concat(typeof offset === 'number' && offset ? "offset=".concat(offset) : '');
                return _context.abrupt("return", dataPumpAPI(url, false).get({
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result || [];
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return TransferStatusImportLayer;
}();